import * as React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { Box, Grid, Tooltip, Typography, useMediaQuery } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { PropsDocumentosAnexos } from '../../shared/VinculacionesModels';
import { useTenant } from '../../shared/Context';

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});
const AnexosForm: React.FC<PropsDocumentosAnexos> = ({ documentosAnexos, setDocumentosAnexos, idVinculacion }) => {
    const today = new Date();

    // Extraer día, mes y año actual
    const getMonth = (number: number) => {
        const date = new Date();
        date.setMonth(date.getMonth() - number);
        return date
    };

    React.useEffect(() => {
        const currentDay = today.getDate();
        const currentMonth = today.getMonth() + 1;
        const currentYear = today.getFullYear();
        setDocumentosAnexos(documentosAnexos.map(doc => {
            if (doc.key === "estadosFinancieros") {
                if (currentMonth > 4 || (currentMonth === 4 && currentDay >= 8)) {
                    doc.label = doc.label.replaceAll("{{year}}", (currentYear - 1).toString())
                } else {
                    doc.label = doc.label.replaceAll("{{year}}", (currentYear - 2).toString())
                }
            }
            if (doc.key === "estadosFinancieros2") {
                if (currentMonth > 4 || (currentMonth === 4 && currentDay >= 8)) {
                    doc.label = doc.label.replaceAll("{{year}}", (currentYear).toString())
                } else {
                    doc.label = doc.label.replaceAll("{{year}}", (currentYear - 1).toString())
                }
            }
            return doc;
        }));
    }, [])
    const { tenantId } = useTenant()
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [loading, setLoading] = React.useState<Record<string, boolean>>(
        documentosAnexos.reduce((acc, doc) => ({ ...acc, [doc.key]: false }), {})
    );

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files) {
            const file = event.target.files[0];
            const nombre = event.target.name;
            setLoading((prevState) => ({ ...prevState, [nombre]: true }));
            handleSubmitFile(file, nombre);
        }
    };
    const handleSubmitFile = (file: File, fileName: string) => {
        if (file) {
            const formData = new FormData();
            formData.append('TenantId', tenantId);
            formData.append('IdVinculacion', idVinculacion);
            formData.append('File', file);
            fetch(process.env.REACT_APP_CORE_LAMBDA_VINCULACIONES_URL + 'cargueDocumento', {
                method: 'POST',
                body: formData
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Error al guardar la información');
                    }
                    setLoading((prevState) => ({ ...prevState, [fileName]: false }));
                    return response.json();
                })
                .then(data => {
                    if (data.url) {
                        setInfoFileUploaded(fileName, data.url);
                    }
                })
                .catch(error => {
                    console.error('Error al guardar la información:', error);
                })
                .finally(() => {

                });
        }
    };
    const setInfoFileUploaded = (fileName: string, url: string) => {
        setDocumentosAnexos((prev) =>
            prev.map((documento) =>
                documento.key === fileName
                    ? { ...documento, url: url }
                    : documento
            )
        );
    }
    const handleViewDocument = (documentKey: string) => {
        fetch(process.env.REACT_APP_CORE_LAMBDA_VINCULACIONES_URL + 'obtengaDocumento', {
            method: 'POST',
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                tenantId: tenantId,
                documentKey: documentKey
            })
        }).then(async (res) => {
            if (!res.ok) {
                throw new Error('Error al guardar la información');
            }
            let response = await res.json()
            window.open(response.signedUrl, "_blank", "noreferrer")
        })
    }
    return (
        <>
            <Typography variant='h6' sx={{ textAlign: 'left', mt: 3, fontWeight: '500' }}>
                Documentos finales
            </Typography>
            <Typography sx={{ textAlign: 'left', mb: 3, fontSize: 14 }}>
                <span style={{ color: 'red', fontWeight: 'bolder', fontSize: '20px', verticalAlign: 'top' }}> * </span> Documentos obligatorios
            </Typography>
            <Grid container >
                {documentosAnexos.map((documento) => (
                    <Grid item xs={12} sx={{ mb: 1 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Grid container sx={{ display: 'flex', alignItems: 'center' }}>
                                <Grid item xs={6} sx={{ textAlign: 'left' }}>
                                    <Typography sx={{ mr: 1 }}>{documento.label} {documento.obligatorio && <span style={{ color: 'red', fontWeight: 'bolder', fontSize: '20px' }}> * </span>}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Box sx={{ textAlign: 'left', ml: 1 }}>
                                        {/* <Tooltip title="La fecha de expedición del documento debe ser inferior a noventa (90) días." arrow> */}
                                        <LoadingButton
                                            component="label"
                                            variant="outlined"
                                            loading={loading[documento.key]}
                                        >
                                            <CloudUploadIcon />
                                            <VisuallyHiddenInput
                                                type="file"
                                                accept=".pdf"
                                                name={documento.key}
                                                onChange={handleFileChange} />
                                        </LoadingButton>
                                        {/* </Tooltip> */}
                                        {documento.url && (
                                            <LoadingButton
                                                component="a"
                                                onClick={() => documento.url && handleViewDocument(documento.url)}
                                                target="_blank"
                                                variant="outlined"
                                                sx={{ ml: !isMobile ? 1 : 0 }}
                                                endIcon={<RemoveRedEyeIcon />}
                                            >
                                                {!isMobile ? "Ver archivo" : "Ver"}
                                            </LoadingButton>
                                        )}
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </>
    );
}

export default AnexosForm;